import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';
import {DashboardComponent} from './dashboard.component.js';

const dashboard = angular.module('dashboard', [uiModal]);

dashboard.component('dashboard', DashboardComponent);

export {dashboard};



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.js